// @ts-check
import { createDataGridContext } from "~/components/Shared/ZeroDataGrid/ZeroDataGrid.context";
import { useContext } from "react";

export const [MembersDataGridContext, MembersDataGridContextProvider] = createDataGridContext('members');

/** @returns {BaseDataGridContextValue} */
export function useMembersDataGridContext() {
    return useContext(MembersDataGridContext);
}
